import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { UploadCloud, Minus, Plus } from 'lucide-react';
// --- Custom Bespoke SVG Illustrations ---
const OfficeIcon = () => <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-208">
    {/* Background Wall/Window */}
    <rect x="20" y="10" width="80" height="60" rx="4" fill="#E8F6F5" data-id="element-209" />
    <rect x="25" y="15" width="32" height="40" rx="2" fill="#2BBCB3" fillOpacity="0.2" data-id="element-210" />
    <rect x="63" y="15" width="32" height="40" rx="2" fill="#2BBCB3" fillOpacity="0.2" data-id="element-211" />
    {/* Desk */}
    <path d="M15 70 L105 70 L110 85 L10 85 Z" fill="#1B1B2F" data-id="element-212" />
    <rect x="25" y="70" width="8" height="20" fill="#2BBCB3" data-id="element-213" />
    <rect x="87" y="70" width="8" height="20" fill="#2BBCB3" data-id="element-214" />
    {/* Monitor */}
    <rect x="45" y="40" width="30" height="20" rx="2" fill="#1B1B2F" data-id="element-215" />
    <rect x="47" y="42" width="26" height="16" rx="1" fill="#2BBCB3" data-id="element-216" />
    <rect x="56" y="60" width="8" height="10" fill="#1B1B2F" data-id="element-217" />
    <rect x="50" y="68" width="20" height="2" fill="#1B1B2F" data-id="element-218" />
    {/* Plant */}
    <path d="M30 60 Q25 50 35 45 Q40 55 30 60" fill="#2BBCB3" data-id="element-219" />
    <path d="M30 60 Q35 45 25 40 Q20 50 30 60" fill="#2BBCB3" data-id="element-220" />
    <rect x="26" y="60" width="8" height="10" fill="#F5C842" data-id="element-221" />
    {/* Chair */}
    <rect x="52" y="75" width="16" height="8" rx="4" fill="#E85D4A" data-id="element-222" />
    <rect x="56" y="83" width="8" height="12" fill="#1B1B2F" data-id="element-223" />
  </svg>;
const ConferenceIcon = () => <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-224">
    {/* Presentation Board */}
    <rect x="30" y="10" width="60" height="40" rx="2" fill="#1B1B2F" data-id="element-225" />
    <rect x="34" y="14" width="52" height="32" fill="#FFFFFF" data-id="element-226" />
    <path d="M40 35 L50 25 L60 30 L75 18" stroke="#E85D4A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-227" />
    <circle cx="75" cy="18" r="3" fill="#E85D4A" data-id="element-228" />
    <rect x="56" y="50" width="8" height="15" fill="#1B1B2F" data-id="element-229" />
    <path d="M45 65 L75 65" stroke="#1B1B2F" strokeWidth="4" strokeLinecap="round" data-id="element-230" />
    {/* Table */}
    <path d="M20 75 L100 75 L115 90 L5 90 Z" fill="#2BBCB3" data-id="element-231" />
    <rect x="25" y="75" width="6" height="15" fill="#1B1B2F" data-id="element-232" />
    <rect x="89" y="75" width="6" height="15" fill="#1B1B2F" data-id="element-233" />
    {/* Chairs & People */}
    <circle cx="35" cy="60" r="8" fill="#F5C842" data-id="element-234" />
    <path d="M25 75 Q35 65 45 75" fill="#1B1B2F" data-id="element-235" />
    <circle cx="60" cy="55" r="8" fill="#E85D4A" data-id="element-236" />
    <path d="M50 75 Q60 60 70 75" fill="#1B1B2F" data-id="element-237" />
    <circle cx="85" cy="60" r="8" fill="#F5C842" data-id="element-238" />
    <path d="M75 75 Q85 65 95 75" fill="#1B1B2F" data-id="element-239" />
  </svg>;
const BathroomIcon = () => <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-240">
    {/* Wall Tiles */}
    <rect x="10" y="10" width="100" height="80" rx="4" fill="#E8F6F5" data-id="element-241" />
    <path d="M10 30 L110 30 M10 50 L110 50 M10 70 L110 70" stroke="#2BBCB3" strokeWidth="1" strokeOpacity="0.3" data-id="element-242" />
    <path d="M30 10 L30 90 M50 10 L50 90 M70 10 L70 90 M90 10 L90 90" stroke="#2BBCB3" strokeWidth="1" strokeOpacity="0.3" data-id="element-243" />
    {/* Mirror */}
    <rect x="45" y="20" width="30" height="25" rx="15" fill="#FFFFFF" stroke="#F5C842" strokeWidth="3" data-id="element-244" />
    {/* Sink */}
    <path d="M40 60 L80 60 Q80 75 60 75 Q40 75 40 60 Z" fill="#1B1B2F" data-id="element-245" />
    <rect x="55" y="50" width="10" height="10" fill="#1B1B2F" data-id="element-246" />
    <path d="M58 52 Q60 45 62 52" stroke="#2BBCB3" strokeWidth="2" strokeLinecap="round" data-id="element-247" />
    {/* Figures */}
    <circle cx="25" cy="35" r="6" fill="#1B1B2F" data-id="element-248" />
    <path d="M20 45 L30 45 L30 65 L26 65 L26 80 L20 80 L20 65 L16 65 Z" fill="#1B1B2F" data-id="element-249" />
    <circle cx="95" cy="35" r="6" fill="#E85D4A" data-id="element-250" />
    <path d="M95 45 L85 65 L105 65 Z" fill="#E85D4A" data-id="element-251" />
    <rect x="91" y="65" width="3" height="15" fill="#E85D4A" data-id="element-252" />
    <rect x="96" y="65" width="3" height="15" fill="#E85D4A" data-id="element-253" />
  </svg>;
const CafeteriaIcon = () => <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-254">
    {/* Counter */}
    <rect x="15" y="40" width="90" height="40" rx="4" fill="#1B1B2F" data-id="element-255" />
    <rect x="15" y="40" width="90" height="10" fill="#2BBCB3" data-id="element-256" />
    {/* Food Display */}
    <rect x="25" y="25" width="40" height="15" fill="#E8F6F5" stroke="#2BBCB3" strokeWidth="2" data-id="element-257" />
    <circle cx="35" cy="35" r="4" fill="#E85D4A" data-id="element-258" />
    <circle cx="45" cy="35" r="4" fill="#F5C842" data-id="element-259" />
    <circle cx="55" cy="35" r="4" fill="#E85D4A" data-id="element-260" />
    {/* Coffee Machine */}
    <rect x="75" y="20" width="20" height="20" rx="2" fill="#F5C842" data-id="element-261" />
    <rect x="80" y="25" width="10" height="8" fill="#1B1B2F" data-id="element-262" />
    <rect x="83" y="40" width="4" height="6" fill="#FFFFFF" data-id="element-263" />
    {/* Stools */}
    <path d="M30 80 L35 95 L25 95 Z" fill="#E85D4A" data-id="element-264" />
    <rect x="25" y="75" width="10" height="5" rx="2" fill="#1B1B2F" data-id="element-265" />
    <path d="M60 80 L65 95 L55 95 Z" fill="#E85D4A" data-id="element-266" />
    <rect x="55" y="75" width="10" height="5" rx="2" fill="#1B1B2F" data-id="element-267" />
    <path d="M90 80 L95 95 L85 95 Z" fill="#E85D4A" data-id="element-268" />
    <rect x="85" y="75" width="10" height="5" rx="2" fill="#1B1B2F" data-id="element-269" />
  </svg>;
const LoungeIcon = () => <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-270">
    {/* Window */}
    <rect x="70" y="10" width="40" height="50" rx="2" fill="#E8F6F5" data-id="element-271" />
    <path d="M70 35 L110 35 M90 10 L90 60" stroke="#2BBCB3" strokeWidth="2" data-id="element-272" />
    {/* Sofa */}
    <rect x="10" y="50" width="60" height="20" rx="4" fill="#E85D4A" data-id="element-273" />
    <rect x="10" y="60" width="60" height="15" rx="4" fill="#1B1B2F" data-id="element-274" />
    <rect x="5" y="55" width="10" height="20" rx="2" fill="#E85D4A" data-id="element-275" />
    <rect x="65" y="55" width="10" height="20" rx="2" fill="#E85D4A" data-id="element-276" />
    {/* Coffee Table */}
    <ellipse cx="85" cy="75" rx="25" ry="8" fill="#F5C842" data-id="element-277" />
    <rect x="70" y="75" width="4" height="15" fill="#1B1B2F" data-id="element-278" />
    <rect x="96" y="75" width="4" height="15" fill="#1B1B2F" data-id="element-279" />
    {/* Lamp */}
    <path d="M25 10 L35 30 L15 30 Z" fill="#F5C842" data-id="element-280" />
    <rect x="24" y="30" width="2" height="20" fill="#1B1B2F" data-id="element-281" />
    {/* Plant */}
    <path d="M95 65 Q90 55 100 50 Q105 60 95 65" fill="#2BBCB3" data-id="element-282" />
    <path d="M95 65 Q100 55 90 50 Q85 60 95 65" fill="#2BBCB3" data-id="element-283" />
    <rect x="91" y="65" width="8" height="10" fill="#1B1B2F" data-id="element-284" />
  </svg>;
// --- Main Component ---
export function BookingForm() {
  // Step 1 State
  const [timeOfDay, setTimeOfDay] = useState('Outside Regular Business hours');
  const [covidContact, setCovidContact] = useState('No');
  // Step 2 State (Counters)
  const [spaces, setSpaces] = useState({
    offices: 0,
    conference: 0,
    bathrooms: 0,
    cafeterias: 1,
    lounging: 0
  });
  const updateSpace = (key: keyof typeof spaces, increment: boolean) => {
    setSpaces(prev => ({
      ...prev,
      [key]: increment ? prev[key] + 1 : Math.max(0, prev[key] - 1)
    }));
  };
  const spaceTypes = [{
    id: 'offices',
    label: 'ENCLOSED Offices Spaces',
    icon: OfficeIcon
  }, {
    id: 'conference',
    label: 'Conference or Meeting rooms',
    icon: ConferenceIcon
  }, {
    id: 'bathrooms',
    label: 'Men & Women Bathrooms',
    icon: BathroomIcon
  }, {
    id: 'cafeterias',
    label: 'Cafeterias & Dining Areas',
    icon: CafeteriaIcon
  }, {
    id: 'lounging',
    label: 'Lounging or Employee / Visitors areas',
    icon: LoungeIcon
  }] as const;
  // Step 3 State
  const percentages = ['0 %', '10 %', '20 %', '30 %', '40 %', '50 %', '60 %', '70 %', '80 %', '90 %', '100 %'];
  // Helper for Step Headings
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-285">
      <div className="flex items-center gap-4 mb-2" data-id="element-286">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md" data-id="element-287">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-288">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-289">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-290"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-291">
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-292">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-293"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-294">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-295">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-296">
              Home
            </Link>
            <span className="mx-2" data-id="element-297">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-298">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-299">/</span>
            <span className="text-accent" data-id="element-300">Request a Quote</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-301">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-302">
              Commercial Cleaning
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-303">
              Request a Quote in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 max-w-5xl mx-auto border border-gray-100" data-id="element-305">
          <div className="text-center mb-16" data-id="element-306">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-307">
              Commercial Cleaning
            </h2>
            <p className="text-xl font-serif italic text-accent mb-4" data-id="element-308">
              Request a Quote in 60 Seconds
            </p>
            <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-309">
              Fill in the questions below and we'll call you back instantly with
              a quote
            </p>
          </div>

          <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-310">
            {/* STEP 1 */}
            <section data-id="element-311">
              <StepHeading number="1" title="Tell us about your commercial space." data-id="element-312" />

              <div className="space-y-6 ml-0 md:ml-14" data-id="element-313">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center" data-id="element-314">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-315">
                    What is the primary use of the space?
                  </label>
                  <input type="text" placeholder="Commercial space" className="md:col-span-2 w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-316" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center" data-id="element-317">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-318">
                    Total Square Footage of entire area you want clean?
                  </label>
                  <input type="text" placeholder="Enter the square footage for the total area that requires cleaning. Feel free to add more info." className="md:col-span-2 w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-319" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center" data-id="element-320">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-321">
                    Height of Ceilings
                  </label>
                  <input type="text" placeholder="Average height of ceiling" className="md:col-span-2 w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-322" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center" data-id="element-323">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-324">
                    Approx. Total # of all persons in the space?
                  </label>
                  <select className="md:col-span-2 w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-325">
                    <option data-id="element-326">1-10</option>
                    <option data-id="element-327">11-25</option>
                    <option data-id="element-328">26-50</option>
                    <option data-id="element-329">51-100</option>
                    <option data-id="element-330">100+</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center" data-id="element-331">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-332">
                    At what frequency would you like to have the cleaning?
                  </label>
                  <select className="md:col-span-2 w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-333">
                    <option data-id="element-334">Daily Including weekends</option>
                    <option data-id="element-335">Daily excluding weekends</option>
                    <option data-id="element-336">Weekly</option>
                    <option data-id="element-337">Bi-weekly</option>
                    <option data-id="element-338">Monthly</option>
                    <option data-id="element-339">One-time</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start md:items-center pt-2" data-id="element-340">
                  <label className="text-primary font-medium md:col-span-1 text-lg" data-id="element-341">
                    What time of day would you like the space cleaned?
                  </label>
                  <div className="md:col-span-2 flex flex-col sm:flex-row rounded-xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-342">
                    {['During Regular Business hours', 'Outside Regular Business hours', 'Overnight (11 pm to 7 am)'].map(time => <button key={time} type="button" onClick={() => setTimeOfDay(time)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${timeOfDay === time ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} ${time !== 'Overnight (11 pm to 7 am)' ? 'border-b sm:border-b-0 sm:border-r border-gray-200' : ''}`} data-id="element-343">
                        {time}
                      </button>)}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center pt-2" data-id="element-344">
                  <label className="text-primary font-medium md:col-span-2 text-lg" data-id="element-345">
                    To your knowledge, has anyone in the space contracted
                    COVID-19 in the last month?
                  </label>
                  <div className="md:col-span-1 flex justify-end" data-id="element-346">
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full sm:w-auto" data-id="element-347">
                      {['Yes', 'No'].map(opt => <button key={opt} type="button" onClick={() => setCovidContact(opt)} className={`flex-1 sm:flex-none py-3.5 px-8 text-sm font-bold transition-all duration-300 ${covidContact === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} ${opt === 'Yes' ? 'border-r border-gray-200' : ''}`} data-id="element-348">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* STEP 2 */}
            <section data-id="element-349">
              <StepHeading number="2" title="Select Space types." subtitle="Select the quantity for each space type in the area you wish cleaned. This will help ensure we provide you the most accurate estimate possible in just a few minutes." data-id="element-350" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ml-0 md:ml-14" data-id="element-351">
                {spaceTypes.map(({
                id,
                label,
                icon: Icon
              }) => <div key={id} className={`bg-gradient-to-b from-gray-50 to-white rounded-2xl p-8 flex flex-col items-center justify-between border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group ${id === 'lounging' ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-352">
                    <h4 className="text-primary font-heading font-bold text-xl text-center mb-6 uppercase tracking-wide group-hover:text-accent transition-colors" data-id="element-353">
                      {label}
                    </h4>

                    <div className="mb-8 transform group-hover:scale-105 transition-transform duration-500" data-id="element-354">
                      <Icon data-id="element-355" />
                    </div>

                    <div className="flex items-center bg-white rounded-full border border-gray-200 shadow-sm overflow-hidden p-1" data-id="element-356">
                      <button type="button" onClick={() => updateSpace(id as keyof typeof spaces, false)} className="w-10 h-10 rounded-full flex items-center justify-center text-primary hover:bg-accent hover:text-white transition-colors" data-id="element-357">
                        <Minus size={20} strokeWidth={2.5} data-id="element-358" />
                      </button>
                      <div className="w-16 text-center font-heading font-bold text-2xl text-primary" data-id="element-359">
                        {spaces[id as keyof typeof spaces]}
                      </div>
                      <button type="button" onClick={() => updateSpace(id as keyof typeof spaces, true)} className="w-10 h-10 rounded-full flex items-center justify-center text-primary hover:bg-accent hover:text-white transition-colors" data-id="element-360">
                        <Plus size={20} strokeWidth={2.5} data-id="element-361" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </section>

            {/* STEP 3 */}
            <section data-id="element-362">
              <StepHeading number="3" title="Type of Flooring" subtitle="Provide your best assessment of the overall flooring type in the area you would like cleaned" data-id="element-363" />

              <div className="space-y-5 ml-0 md:ml-14" data-id="element-364">
                {['Wood - Approximate % of the total floor space?', 'Cement - Approximate % of the floor space?', 'Carpeting - Approximate % of the floor space? (excludes area & moveable rugs)', 'Ceramic/Marble/Finished stone - Approximate % of the floor space?'].map((label, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-365">
                    <label className="text-primary font-medium text-lg" data-id="element-366">
                      {label}
                    </label>
                    <select className="w-full sm:w-32 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-bold appearance-none cursor-pointer text-center shadow-sm" data-id="element-367">
                      {percentages.map(p => <option key={p} data-id="element-368">{p}</option>)}
                    </select>
                  </div>)}

                <div className="pt-6" data-id="element-369">
                  <label className="text-primary font-medium block mb-3 text-lg" data-id="element-370">
                    Is there any other information regarding the floor space?
                  </label>
                  <textarea placeholder="Please add any other information you feel we should know about and is pertinent or missing in the above." className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-371"></textarea>
                </div>
              </div>
            </section>

            {/* Add Photos */}
            <section data-id="element-372">
              <div className="mb-8" data-id="element-373">
                <div className="flex items-center gap-4 mb-2" data-id="element-374">
                  <div className="w-10 h-10 rounded-full bg-gold flex items-center justify-center text-primary font-heading font-bold text-xl shadow-md" data-id="element-375">
                    <UploadCloud size={20} data-id="element-376" />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-377">
                    Add photos (optional)
                  </h3>
                </div>
                <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-378">
                  Upload photos or images you feel may help. Supported files are
                  png, jpg, jpeg or PDF.
                </p>
              </div>

              <div className="ml-0 md:ml-14" data-id="element-379">
                <div className="border-2 border-dashed border-accent/30 rounded-2xl p-12 flex flex-col items-center justify-center bg-accent/5 hover:bg-accent/10 transition-colors cursor-pointer group relative overflow-hidden" data-id="element-380">
                  <div className="absolute inset-0 bg-white/40 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-381"></div>
                  <UploadCloud className="w-16 h-16 text-accent mb-4 transform group-hover:scale-110 transition-transform duration-300 relative z-10" data-id="element-382" />
                  <p className="text-primary font-medium text-lg mb-2 relative z-10" data-id="element-383">
                    Drag your files here or{' '}
                    <span className="text-accent font-bold underline decoration-2 underline-offset-4" data-id="element-384">
                      Browse
                    </span>
                  </p>
                  <p className="text-gray-500 text-sm relative z-10" data-id="element-385">
                    Maximum file size: 10MB
                  </p>
                </div>
              </div>
            </section>

            {/* STEP 4 */}
            <section data-id="element-386">
              <StepHeading number="4" title="Let us know who we'll be contacting?" subtitle="You will instantly receive an email summarizing the information entered in this Quote Request. In addition, we will call you within the next 10 minutes to provide you a quote. Thanks you & talk real soon!" data-id="element-387" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-388">
                <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-389" />
                <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-390" />
                <input type="email" placeholder="Email Address" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-391" />
                <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-392">
                  <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-393">
                    🇬🇧 ▾
                  </div>
                  <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-394" />
                </div>
              </div>
            </section>

            {/* STEP 5 */}
            <section data-id="element-395">
              <StepHeading number="5" title="Location of the commercial space" data-id="element-396" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-397">
                <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-398" />
                <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-399" />
                <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-400" />
                <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-401" />
              </div>
            </section>

            {/* Submit */}
            <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-402">
              <button type="submit" className="bg-accent hover:bg-accent/90 text-white px-16 py-5 rounded-full text-xl font-heading font-bold uppercase tracking-widest transition-all transform hover:-translate-y-1 shadow-xl hover:shadow-2xl hover:shadow-accent/30 flex items-center gap-3" data-id="element-403">
                Request a quote
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-404">
                  <line x1="5" y1="12" x2="19" y2="12" data-id="element-405"></line>
                  <polyline points="12 5 19 12 12 19" data-id="element-406"></polyline>
                </svg>
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </main>;
}